// extracted by mini-css-extract-plugin
export default {"input":"StandardInput_input__YnYGW","error":"StandardInput_error__U94Qt"};